const StyleSection = ({ children, title, className }) => {
    return (
        <div className={className}>
            {!!title && <div className="input-label">{title}</div>}
            <div className="rounded-lg w-full bg-gray-200 p-6">{children}</div>
        </div>
    );
};

export default StyleSection;
